module.exports = __webpack_public_path__ + "static/media/Door_After.6ba25ac5.jpg";